export const module_sponsor_exemptions_users = "module_sponsor_exemptions_users";
export const module_sponsor_exemptions = "module_sponsor_exemptions";
export const module_subscription = "subscriptionmodule";
export const module_sponsor = "module_sponsor";
export const module_onlime = "module_onlime";
export const module_payment = "module_payment";
export const module_payment_mobilepay = "module_payment_mobilepay";
export const module_payment_mobilepaysubscription = "module_payment_mobilepaysubscription";
export const module_ambassador = "module_ambassador";
export const module_activity = "module_activity";
export const module_chat = "module_chat";
export const module_dashboard = "module_dashboard";
export const module_mobileapp_webinfo = "module_mobileapp_webinfo";
export const module_member_signuplink_showwebbutton = "module_member_signuplink_showwebbutton";
export const module_integrations = "module_integrations";
